module.exports = __webpack_public_path__ + "static/media/bookshelf.a5ad05f8.svg";